import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site';
/**
 * Checks if the current locale is an international locale.
 * @returns {boolean} True if the current locale is an international locale, false otherwise.
 */
const useIsInternational = () => {
    const { locale } = useMultiSite();
    return !!locale.isSupportedByESW;
};

export default useIsInternational;